import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth, useHasPermission } from "../../context/AuthContext";
import { getDefaultAuthenticatedRoute } from "../../lib/userAccess";

/**
 * Route guard on an effective permission from /auth/me. Mounted inside ProtectedRoute, which
 * holds rendering until /auth/me has resolved, so an empty list here really means "not granted".
 */
export function RequirePermission({ permission, children }: { permission: string; children: ReactNode }) {
  const { user } = useAuth();
  const allowed = useHasPermission(permission);
  if (!allowed) return <Navigate to={getDefaultAuthenticatedRoute(user)} replace />;
  return <>{children}</>;
}
